import { render } from "./GalleryView.vue?vue&type=template&id=9bb678d0&scoped=true"
import script from "./GalleryView.vue?vue&type=script&lang=js"
export * from "./GalleryView.vue?vue&type=script&lang=js"

import "./GalleryView.vue?vue&type=style&index=0&id=9bb678d0&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bb678d0"]])

export default __exports__